// extracted by mini-css-extract-plugin
export default {"labeled-input-container":"Input_labeled-input-container__HeudQ","label":"Input_label__eZ-QC"};